import supabase from "../supabase";

/**
 * `employeeId` del usuario logueado.
 *
 * El login sólo guarda el nombre, así que el id hay que resolverlo contra la
 * tabla `employees` por el `uid` de Supabase. Se cachea en memoria porque no
 * cambia dentro de una sesión y lo consultan varias pantallas.
 */
let cache = null;

export const getCurrentEmployeeId = async () => {
  if (cache !== null) return cache;

  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await supabase
    .from("employees")
    .select("employeeId")
    .eq("uid", user.id)
    .single();

  if (error || !data) {
    console.error("No se pudo resolver el empleado del usuario:", error?.message);
    return null;
  }

  cache = data.employeeId;
  return cache;
};

/** Al cerrar sesión: si no, el próximo usuario hereda el id del anterior. */
export const clearCurrentEmployeeCache = () => {
  cache = null;
};
